// extracted by mini-css-extract-plugin
module.exports = {"SalesCategroyTable":"SalesCategroyTable___CZI7Z","HideSalesCategroyTable":"HideSalesCategroyTable___2yZs5"};